import styled, { css } from 'styled-components';

import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

const Button = styled.button<{
  size?: 'default' | 'small' | 'tiny';
  design?: 'primary' | 'secondary' | 'tertiary' | 'action';
}>`
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: none;
  outline: none;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;

  text-wrap: nowrap;
  border-radius: 100px;
  font-weight: 600;

  ${({ design }) => {
    switch (design) {
      case 'secondary':
        return css`
          color: ${colors.shade100};
          background: ${colors.verseNavBlue};
          box-shadow: 0px 1px 1px 0px #ffffff26 inset;

          &:hover,
          &:focus {
            background: ${colors.gradientSecondaryHover};
          }
          &:active {
            background: ${colors.gradientSecondaryActive};
          }
          &:disabled {
            background: #1a2231;
            color: ${colors.shade50};
          }
        `;
      case 'tertiary':
        return css`
          color: ${colors.shade90};
          background: #1a2231;

          &:hover,
          &:focus {
            color: ${colors.shade100};
            background: #313e57;
          }
          &:active {
            color: ${colors.shade100};
            background: #252d40;
          }
          &:disabled {
            background: #1a2231;
            color: ${colors.shade50};
          }
        `;
      case 'action':
        return css`
          color: ${colors.shade100};
          font-family: Barlow, sans-serif;
          line-height: 14.4px;
          background: linear-gradient(
            180deg,
            rgba(28, 170, 255, 255) 0%,
            rgba(0, 120, 211, 255) 100%
          );
          box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.02),
            0px 10px 38px rgba(45, 50, 59, 0.03),
            0px 4px 14px rgba(45, 50, 59, 0.05),
            0px 1px 5px rgba(45, 50, 59, 0.08);

          &:hover,
          &:active,
          &:focus {
            box-shadow: 0px 6px 6px rgba(0, 123, 255, 0.2),
              0px 8px 10px rgba(0, 125, 255, 0.25);
          }

          &:focus {
            outline: none;
          }
        `;

      case 'primary':
      default:
        return css`
          color: ${colors.shade100};
          background: linear-gradient(90deg, #2563eb 0%, #9333ea 100%);

          &:hover,
          &:focus {
            background: linear-gradient(90deg, #2569fa 0%, #9333ea 100%);
          }
          &:active {
            background: linear-gradient(90deg, #2569fa 0%, #9333ea 100%);
          }
          &:disabled {
            background: ${colors.shade30};
            color: ${colors.shade50};
            cursor: default;
          }
        `;
    }
  }}

  ${({ size }) => {
    switch (size) {
      case 'small':
        return css`
          font-size: 14px;
          height: 36px;
          padding: 0px 16px;
        `;
      case 'tiny':
        return css`
          font-size: 12px;
          height: 24px;
          padding: 0px 12px;
        `;
      case 'default':
      default:
        return css`
          font-size: 18px;
          height: 48px;
          padding: 0px 24px;
        `;
    }
  }}
`;

export default Button;
